import { Pipe, PipeTransform } from '@angular/core';
import { TableCell, TableCellValue, TableColumn } from '@nagel-types';

@Pipe({
    name: 'mapCell',
    pure: true
})
export class MapCellPipe implements PipeTransform {
    transform(column: TableColumn, element: Record<string, TableCellValue>): TableCell {
        return {
            type: column.type,
            value: element[column.columnDef],
            options: column.options
        };
    }
}
